import React, { Component } from 'react';

import { ReactComponent as ArrowUpRight } from 'components/svg/icons/arrow-up-right.svg';
import { I18n } from 'components/translate';
import Settings from 'configs/Settings';
import { inject } from 'mobx-react';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import GtagService from 'modules/app/services/ga/GtagService';
import PropTypes from 'prop-types';

import { getTranslateKey } from './settings';

import OnboardingService from '../../OnboardingService';

import './style.scss';

@inject((stores) => ({
  productId: stores.MembershipStore.productId,
  isOnlineEvent: stores.MembershipStore.onlineEvent
}))
class Finished extends Component {
  static propTypes = {
    history: PropTypes.object,
    productId: PropTypes.number,
    isOnlineEvent: PropTypes.bool
  };

  static defaultProps = {
    isOnlineEvent: false
  };

  handleClickCta = () => {
    GtagService.sendEvent({
      event: 'interaction',
      category: 'Club:Admin:Content',
      action: 'Click',
      where: 'Onboarding',
      label: 'GoToHotmart'
    });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.CONTENT.CONTENT_ONBOARDING,
        action: EVENTS_INTERACTIONS.CLICK,
        label: EVENTS_LABELS.CONTENT.CONTENT_ONBOARDING.BACK_TO_REGISTER
      })
    });
  };

  componentDidMount() {
    OnboardingService.convertionEvent();
  }

  render() {
    const { productId, isOnlineEvent } = this.props;
    const labels = getTranslateKey(isOnlineEvent);

    return (
      <div>
        <h2 className="onboarding-finished__title">
          <I18n label={labels.title} />
        </h2>
        <p className="onboarding-finished__message">
          <I18n html label={labels.subtitle} />
        </p>
        <a
          href={`${Settings.app.bw}/products/manage/${productId}`}
          target="_Blank"
          onClick={this.handleClickCta}
          className="onboarding-finished__go-registration"
          rel="noopener noreferrer"
        >
          <I18n label={labels.cta} />
          <ArrowUpRight className="onboarding-finished__icon-go-registration" />
        </a>
      </div>
    );
  }
}

export default Finished;
